import React, { useEffect, useState, useCallback, useRef } from "react";
import { useNavigate } from "react-router-dom";
import CreatableSelect from 'react-select/creatable';
import {
    Modal, Button, Badge, Card, Row, Col,
    Container, Spinner, ButtonGroup,
    ToggleButton, Form, InputGroup, Collapse
} from 'react-bootstrap';
import { api } from '../../services/api.js';
import Menu from '../../comum/Menu/menu.jsx';
import Footer from '../../comum/Footer/index.jsx';
import Foto from "../Components/Foto";
import PdfFullscreen from "../Components/Foto/pdf.jsx";
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import './atendimento.css';

function AtendimentoTecnico() {
    const chapa = localStorage.getItem("chapa") || "";

    const [chamados, setChamados] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filtroStatus, setFiltroStatus] = useState('Em Espera');
    const [setorSelecionado, setSetorSelecionado] = useState(() => {
        return localStorage.getItem("@Arbor:setorSelecionado") || "";
    });
    const [anexosAbertura, setAnexosAbertura] = useState([]);
    const [fotoSelecionada, setFotoSelecionada] = useState(null);
    const [pdfSelecionado, setPdfSelecionado] = useState(null);
    const [statusSetor, setStatusSetor] = useState([]);
    const [statusSelecionado, setStatusSelecionado] = useState("");
    const chatContainerRef = useRef(null);
    const [urlParaVisualizar, setUrlParaVisualizar] = useState("");
    const navigate = useNavigate();
    const [segundosParaAtualizar, setSegundosParaAtualizar] = useState(180);
    const [lojasSelecionadas, setLojasSelecionadas] = useState(() => {
        const salvo = localStorage.getItem("@Arbor:filtroLojas");
        return salvo ? JSON.parse(salvo) : [];
    });
    const [modoSomenteLeitura, setModoSomenteLeitura] = useState(false);

    const removerAnexo = (indexParaRemover) => {
        setAnexosNovos(prev => prev.filter((_, index) => index !== indexParaRemover));
    };
    const [fullscreenPdf, setFullscreenPdf] = useState(false);

    const [setoresPermitidosFormatados, setSetoresPermitidosFormatados] = useState([]);
    const [categoriasSetor, setCategoriasSetor] = useState([]);

    const [showDetalhes, setShowDetalhes] = useState(false);
    const [chamadoSelecionado, setChamadoSelecionado] = useState(null);
    const [interacoes, setInteracoes] = useState([]);
    const [loadingDetalhes, setLoadingDetalhes] = useState(false);

    const [dadosEquipamento, setDadosEquipamento] = useState(null);

    const [showConsultaPai, setShowConsultaPai] = useState(false);
    const [chamadoPaiDados, setChamadoPaiDados] = useState(null);
    const [interacoesPai, setInteracoesPai] = useState([]);
    const [anexosPai, setAnexosPai] = useState([]);
    const [loadingPai, setLoadingPai] = useState(false);

    const [novaMsg, setNovaMsg] = useState("");
    const [anexosNovos, setAnexosNovos] = useState([]);
    const [enviandoInt, setEnviandoInt] = useState(false);
    const [atualizandoCategoria, setAtualizandoCategoria] = useState(false);
    const MySwal = withReactContent(Swal);
    const [filtroCategoria, setFiltroCategoria] = useState("");
    const [filtroData, setFiltroData] = useState("");
    const [filtroNumChamado, setFiltroNumChamado] = useState("");
    const [filtroDescricao, setFiltroDescricao] = useState("");

    const [filtroMeusAtendimentos, setFiltroMeusAtendimentos] = useState(false);
    const [showFiltrosAvancados, setShowFiltrosAvancados] = useState(false);

    const [showModalMemo, setShowModalMemo] = useState(false);

    const [editandoSerie, setEditandoSerie] = useState(false);
    const [novaSerieInput, setNovaSerieInput] = useState("");
    const [salvandoSerie, setSalvandoSerie] = useState(false);

    const [pagina, setPagina] = useState(1);
    const [temMais, setTemMais] = useState(true);

    const LIMITE = 15;

    const abrirModalMemo = () => {
        setNovaMsg("");
        setAnexosNovos([]);

        // 1. Pega o status atual numérico do chamado (ex: 0)
        const stAtual = Number(
            chamadoSelecionado?.status ?? chamadoSelecionado?.STATUS ??
            chamadoSelecionado?.id_status ?? chamadoSelecionado?.ID_STATUS ?? -1
        );

        // 2. Extrai dinamicamente todos os IDs de status que vieram do Backend para este setor
        const idsStatusDoBackend = (statusSetor || []).map(st => Number(
            st.id_status ?? st.ID_STATUS ??
            st.id_status_setor ?? st.ID_STATUS_SETOR ??
            st.codigo ?? st.CODIGO
        ));

        // Adiciona o status fixo de conclusão
        idsStatusDoBackend.push(90);

        // 3. Se o status atual do chamado EXISTE na lista do setor, mantém ele
        if (stAtual >= 0 && idsStatusDoBackend.includes(stAtual)) {
            setStatusSelecionado(stAtual);
        }
        // 4. Se NÃO EXISTE (ex: status 0 - Solicitado), pega dinamicamente o PRIMEIRO id retornado pelo backend
        else if (statusSetor && statusSetor.length > 0) {
            const primeiroItem = statusSetor[0];
            const primeiroIdValido = Number(
                primeiroItem.id_status ?? primeiroItem.ID_STATUS ??
                primeiroItem.id_status_setor ?? primeiroItem.ID_STATUS_SETOR ??
                primeiroItem.codigo ?? primeiroItem.CODIGO
            );
            setStatusSelecionado(primeiroIdValido);
        } else {
            setStatusSelecionado(90);
        }

        setShowModalMemo(true);
    };

    const renderTextoComLinks = (texto) => {
        if (!texto) return "";
        const urlRegex = /(https?:\/\/[^\s]+)/g;
        const partes = texto.split(urlRegex);

        return partes.map((parte, index) => {
            if (parte.match(urlRegex)) {
                return (
                    <a
                        key={index}
                        href={parte}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ wordBreak: 'break-all', textDecoration: 'underline', color: '#8b0000' }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        {parte}
                    </a>
                );
            }
            return <span key={index} style={{ whiteSpace: 'pre-wrap' }}>{parte}</span>;
        });
    };

    useEffect(() => {
        if (showDetalhes) {
            window.scrollTo(0, 1);
        }
    }, [showDetalhes]);

    useEffect(() => {
        const numSerie = chamadoSelecionado?.numero_serie || chamadoSelecionado?.NUMERO_SERIE;
        if (showDetalhes && numSerie && numSerie.trim() !== "" && numSerie.toUpperCase() !== "NÃO INFORMADO") {
            api.get(`/chamado/equipamento/${encodeURIComponent(numSerie.trim())}`)
                .then(res => setDadosEquipamento(res.data))
                .catch(() => setDadosEquipamento(null));
        } else {
            setDadosEquipamento(null);
        }
    }, [showDetalhes, chamadoSelecionado]);

    const formatarNomePrimeiro = (nome) => {
        if (!nome) return "";
        const primeiro = nome.split(" ")[0].toLowerCase();
        return primeiro.charAt(0).toUpperCase() + primeiro.slice(1);
    };

    const decodeBase64 = (str) => {
        try {
            if (!str || typeof str !== "string") return "";
            let base64 = str.replace(/\s/g, "");
            const binary = window.atob(base64);
            const bytes = Uint8Array.from(binary, c => c.charCodeAt(0));
            try {
                return new TextDecoder("utf-8", { fatal: true }).decode(bytes);
            } catch (e) {
                return new TextDecoder("iso-8859-1").decode(bytes);
            }
        } catch (e) { return str; }
    };

    const handlePaste = (e) => {
        const items = e.clipboardData.items;
        let temImagem = false;

        for (let i = 0; i < items.length; i++) {
            if (items[i].type.indexOf("image") !== -1) {
                temImagem = true;

                const blob = items[i].getAsFile();
                const file = new File([blob], `print_${Date.now()}.png`, { type: blob.type });

                const reader = new FileReader();
                reader.onloadend = () => {
                    setAnexosNovos(prev => [
                        ...prev,
                        {
                            nome: file.name,
                            base64: reader.result.split(',')[1]
                        }
                    ]);
                };

                reader.readAsDataURL(file);
            }
        }

        if (temImagem) {
            e.preventDefault();
            toast.info("📸 Print anexado automaticamente!");
        }
    };

    const handleSubmitInteracao = async (usarStatusAtual = false) => {
        if (!chapa) {
            toast.error("Sessão não identificada. Por favor, recarregue a página.");
            return;
        }

        const statusOriginal = chamadoSelecionado?.status ?? chamadoSelecionado?.STATUS ??
            chamadoSelecionado?.id_status ?? chamadoSelecionado?.ID_STATUS;

        let statusParaAplicar = usarStatusAtual ? Number(statusOriginal) : Number(statusSelecionado);

        // Garante que não envie NaN ou negativo
        if (isNaN(statusParaAplicar) || statusParaAplicar < 0) {
            toast.warning("Por favor, selecione um STATUS válido para o chamado!");
            return;
        }

        const mensagemFinal = novaMsg.trim();
        if (!mensagemFinal) {
            toast.warning("Digite uma mensagem para enviar.");
            return;
        }

        await realizarAcao(statusParaAplicar);
        setShowModalMemo(false);
    };

    useEffect(() => {
        if (pdfSelecionado?.base64) {
            const base64Limpo = pdfSelecionado.base64.split(',')[1] || pdfSelecionado.base64;
            try {
                const byteCharacters = atob(base64Limpo);
                const byteNumbers = new Uint8Array(byteCharacters.length);

                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }

                const nomeArquivo = (pdfSelecionado.nome || "").toLowerCase();
                const isTxt = nomeArquivo.endsWith('.txt') || nomeArquivo.endsWith('.txt_conv');
                const tipoMime = isTxt ? 'text/plain' : 'application/pdf';

                const blob = new Blob([byteNumbers], { type: tipoMime });
                const url = URL.createObjectURL(blob);

                setUrlParaVisualizar(url);
                return () => URL.revokeObjectURL(url);
            } catch (e) {
                console.error("Erro ao converter anexo:", e);
            }
        }
    }, [pdfSelecionado]);

    useEffect(() => {
        async function carregarSetores() {
            try {
                const permissõesLocalStorage = JSON.parse(localStorage.getItem("setorchamado") || "[]");

                if (permissõesLocalStorage.length === 0) {
                    await Swal.fire({
                        icon: 'error',
                        title: 'Acesso Negado',
                        text: 'O Usuário não tem permissão para acessar este módulo.',
                        confirmButtonColor: '#8b0000'
                    });
                    navigate('/arbor/home');
                    return;
                }

                const codigosPermitidos = permissõesLocalStorage.map(c => String(c));
                const res = await api.get('/chamados/setores');
                const todosSetores = res.data || [];

                const filtrados = todosSetores.filter(s =>
                    codigosPermitidos.includes(String(s.id_setor || s.codigo))
                );

                if (filtrados.length === 0) {
                    await Swal.fire({
                        icon: 'warning',
                        title: 'Permissão Inválida',
                        text: 'Nenhum setor vinculado às suas permissões foi encontrado.',
                        confirmButtonColor: '#8b0000'
                    });
                    navigate('/arbor/home');
                    return;
                }

                setSetoresPermitidosFormatados(filtrados);

                const setorSalvo = localStorage.getItem("@Arbor:setorSelecionado");
                const setorValido = filtrados.some(s => String(s.id_setor || s.codigo) === String(setorSalvo));

                if (setorSalvo && setorValido) {
                    setSetorSelecionado(String(setorSalvo));
                } else if (filtrados.length > 0) {
                    const idPadrao = String(filtrados[0].id_setor || filtrados[0].codigo);
                    setSetorSelecionado(idPadrao);
                    localStorage.setItem("@Arbor:setorSelecionado", idPadrao);
                }
            } catch (err) {
                console.error(err);
                toast.error("Erro ao carregar lista de setores");
            }
        }
        carregarSetores();
    }, [navigate]);

    useEffect(() => {
        localStorage.setItem("@Arbor:filtroLojas", JSON.stringify(lojasSelecionadas));
    }, [lojasSelecionadas]);

    useEffect(() => {
        if (setorSelecionado) {
            api.get(`/chamados/categorias?setor=${setorSelecionado}`)
                .then(res => setCategoriasSetor(res.data || []))
                .catch(() => toast.error("Erro ao carregar categorias"));
        }
    }, [setorSelecionado]);

    useEffect(() => {
        if (chatContainerRef.current) {
            const container = chatContainerRef.current;
            container.scrollTo({
                top: container.scrollHeight,
                behavior: "smooth"
            });
        }
    }, [interacoes]);

    useEffect(() => {
        if (setorSelecionado) {
            api.get(`/chamados/status?setor=${setorSelecionado}`)
                .then(res => setStatusSetor(res.data || []))
                .catch(() => toast.error("Erro ao carregar status do setor"));
        };
    }, [setorSelecionado]);

    const carregandoRef = useRef(false);

    const carregarChamados = useCallback(async (novaPagina = 1) => {
        if (!setorSelecionado) return;
        if (carregandoRef.current) return;

        carregandoRef.current = true;
        setLoading(true);

        if (novaPagina === 1) {
            setChamados([]);
        }

        try {
            let st = -1;
            let usr = "";
            if (filtroStatus === "Em Espera") {
                st = 1
            } else if (filtroStatus === "Em Atendimento") {
                usr = "T";
                st = 2
            } else if (filtroStatus === "Aguardando Usuário") {
                usr = "U";
            } else if (filtroStatus === "Aguardando Avaliação") {
                st = 90;
                usr = "X";
            } else if (filtroStatus === "Encerrados") {
                st = 99;
                usr = "X";
            }

            const filtroLojasStr = lojasSelecionadas.map(l => l.value).join(',');

            const res = await api.get(`/chamados`, {
                params: {
                    depend: usr,
                    loja: -1,
                    usuario: '',
                    usuarioAtendendo: filtroMeusAtendimentos ? chapa : '',
                    status: st,
                    setor: setorSelecionado,
                    filtroLojas: filtroLojasStr,
                    pagina: novaPagina,
                    limite: LIMITE,
                    categoriaChamado: filtroCategoria,
                    dataChamado: filtroData,
                    numChamado: filtroNumChamado === "" ? 0 : Number(filtroNumChamado),
                    descricaoChamado: filtroDescricao
                }
            });

            const dados = res.data || [];

            if (novaPagina === 1) {
                setChamados(dados);
            } else {
                setChamados(prev => [...prev, ...dados]);
            }

            setTemMais(dados.length === LIMITE);
            setPagina(novaPagina);

        } catch (err) {
            console.error(err);
            toast.error("Erro ao carregar chamados");
        } finally {
            carregandoRef.current = false;
            setLoading(false);
        }
    }, [setorSelecionado, filtroStatus, lojasSelecionadas, filtroCategoria, filtroData, filtroNumChamado, filtroDescricao, filtroMeusAtendimentos, chapa, LIMITE]);

    useEffect(() => {
        if (setorSelecionado) {
            carregarChamados(1);
        }
    }, [setorSelecionado, filtroStatus, lojasSelecionadas, filtroCategoria, filtroData, filtroNumChamado, filtroDescricao, filtroMeusAtendimentos, carregarChamados]);

    useEffect(() => {
        if (setorSelecionado) {
            const intervalo = setInterval(() => {
                setSegundosParaAtualizar((prev) => {
                    if (prev <= 1) {
                        carregarChamados(1);
                        return 180;
                    }
                    return prev - 1;
                });
            }, 1000);

            return () => clearInterval(intervalo);
        }
    }, [setorSelecionado, carregarChamados]);

    const handleFileChange = (e) => {
        const files = Array.from(e.target.files);
        files.forEach(file => {
            const reader = new FileReader();
            reader.onloadend = () => {
                setAnexosNovos(prev => [...prev, {
                    nome: file.name,
                    base64: reader.result.split(',')[1]
                }]);
            };
            reader.readAsDataURL(file);
        });
        e.target.value = null;
    };

    const abrirDetalhes = async (chamado) => {
        let somenteLeitura = false;
        const idChamado = chamado.id_chamado || chamado.ID_CHAMADO;
        const statusAtual = Number(chamado.status || chamado.STATUS || 0);
        const dpSetor = String(chamado.dp_setor || chamado.DP_SETOR || "").toUpperCase();

        if (statusAtual >= 90 || dpSetor === 'X') {
            somenteLeitura = true;
        } else {
            const resultIntencao = await Swal.fire({
                title: 'Acesso ao Chamado',
                text: "Você irá iniciar o atendimento deste chamado agora?",
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Sim, iniciar atendimento',
                cancelButtonText: 'Apenas consultar',
                confirmButtonColor: '#8b0000',
                cancelButtonColor: '#6c757d',
            });

            if (resultIntencao.isConfirmed) {
                try {
                    const resAssumir = await api.post('/chamados/assumir', {
                        id: idChamado,
                        usuario: chapa,
                        forcar: false
                    });

                    if (resAssumir.data.status === 'ocupado') {
                        const resultValidação = await Swal.fire({
                            title: 'Chamado Ocupado',
                            html: `O técnico <b>${resAssumir.data.tecnico}</b> já está atendendo este chamado.<br/><br/> Para assumir o atendimento mesmo assim, digite <b>ASSUMIR</b> abaixo:`,
                            icon: 'warning',
                            input: 'text',
                            inputPlaceholder: 'Digite ASSUMIR',
                            showCancelButton: true,
                            confirmButtonText: 'Assumir Chamado',
                            cancelButtonText: 'Cancelar',
                            confirmButtonColor: '#dc3545',
                            inputValidator: (value) => {
                                if (!value || value.trim().toUpperCase() !== 'ASSUMIR') {
                                    return 'Você precisa digitar a palavra ASSUMIR para continuar!';
                                }
                            }
                        });

                        if (resultValidação.isConfirmed) {
                            const resForcar = await api.post('/chamados/assumir', {
                                id: idChamado,
                                usuario: chapa,
                                forcar: true
                            });

                            if (resForcar.data.status === 'ok') {
                                toast.success("Você assumiu o chamado com sucesso.");
                                somenteLeitura = false;
                            }
                        } else {
                            return;
                        }
                    }
                } catch (err) {
                    console.error("Erro ao assumir chamado:", err);
                }
            } else if (resultIntencao.dismiss === Swal.DismissReason.cancel) {
                somenteLeitura = true;
            } else {
                return;
            }
        }

        setEditandoSerie(false);
        setNovaSerieInput(chamado.numero_serie || chamado.NUMERO_SERIE || "");

        setModoSomenteLeitura(somenteLeitura);
        setChamadoSelecionado(chamado);
        setStatusSelecionado("");
        setShowDetalhes(true);
        setLoadingDetalhes(true);

        try {
            const resInt = await api.get(`/chamado/${idChamado}/interacoes`);
            const listaInteracoes = resInt.data || [];

            const interacoesComAnexos = await Promise.all(
                listaInteracoes.map(async (i) => {
                    try {
                        const idInteracao = i.id_interacao || i.ID_INTERACAO;
                        const resAnexo = await api.get(`/chamado/anexos?id=${idChamado}&id_interacao=${idInteracao}`);
                        return { ...i, ANEXOS: resAnexo.data || [] };
                    } catch {
                        return { ...i, ANEXOS: [] };
                    }
                })
            );

            const resAnexosAbertura = await api.get(`/chamado/anexos?id=${idChamado}&id_interacao=0`);
            setInteracoes(interacoesComAnexos);
            setAnexosAbertura(resAnexosAbertura.data || []);
        } catch (err) {
            toast.error("Erro ao carregar dados");
        } finally {
            setLoadingDetalhes(false);
        }
    };

    const abrirConsultaChamadoPai = async (e, idPai) => {
        if (e) e.stopPropagation();
        setLoadingPai(true);
        setShowConsultaPai(true);

        try {
            const resChamado = await api.get(`/chamado/${idPai}`);
            const dadosPai = Array.isArray(resChamado.data) ? resChamado.data[0] : resChamado.data;
            setChamadoPaiDados(dadosPai);

            const resInt = await api.get(`/chamado/${idPai}/interacoes`);
            const interacoesComAnexos = await Promise.all(
                (resInt.data || []).map(async (i) => {
                    try {
                        const idInteracao = i.ID_INTERACAO || i.id_interacao;
                        const resAnexo = await api.get(`/chamado/anexos?id=${idPai}&id_interacao=${idInteracao}`);
                        return { ...i, ANEXOS: resAnexo.data || [] };
                    } catch {
                        return { ...i, ANEXOS: [] };
                    }
                })
            );

            const resAnexos = await api.get(`/chamado/anexos?id=${idPai}&id_interacao=0`);
            setInteracoesPai(interacoesComAnexos);
            setAnexosPai(resAnexos.data || []);
        } catch (err) {
            console.error(err);
            toast.error("Erro ao carregar dados do chamado pai.");
        } finally {
            setLoadingPai(false);
        }
    };

    const salvarNovaSerie = async () => {
        const idChamado = chamadoSelecionado?.id_chamado || chamadoSelecionado?.ID_CHAMADO;
        const serieTratada = novaSerieInput.trim().toUpperCase();

        try {
            setSalvandoSerie(true);
            await api.put('/chamado/serie', {
                id_chamado: idChamado,
                numero_serie: serieTratada,
                usuario: chapa
            });

            toast.success("Número de Série atualizado com sucesso!");

            const objetoAtualizado = {
                ...chamadoSelecionado,
                numero_serie: serieTratada,
                NUMERO_SERIE: serieTratada
            };

            setChamadoSelecionado(objetoAtualizado);
            setEditandoSerie(false);

            await abrirDetalhes(objetoAtualizado);
            carregarChamados(pagina);
        } catch (err) {
            console.error(err);
            toast.error("Erro ao atualizar o Número de Série.");
        } finally {
            setSalvandoSerie(false);
        }
    };

    const alterarCategoria = async (idNovaCat, nomeNovaCat) => {
        const resultado = await MySwal.fire({
            title: 'Confirmar Alteração?',
            text: `Deseja alterar a categoria para: ${nomeNovaCat}?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#8b0000',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, alterar!',
            cancelButtonText: 'Cancelar'
        });

        if (resultado.isConfirmed) {
            setAtualizandoCategoria(true);
            try {
                await api.put('/chamado/categoria', {
                    id_chamado: chamadoSelecionado.id_chamado || chamadoSelecionado.ID_CHAMADO,
                    id_nova_categoria: idNovaCat,
                    usuario: chapa,
                    categoria_antiga_nome: chamadoSelecionado.nome_categoria || chamadoSelecionado.categoria_nome,
                    nova_categoria_nome: nomeNovaCat
                });

                MySwal.fire({
                    title: 'Sucesso!',
                    text: 'Categoria atualizada e histórico registrado.',
                    icon: 'success',
                    timer: 2000,
                    showConfirmButton: false
                });

                setChamadoSelecionado(prev => ({ ...prev, id_categoria: idNovaCat, nome_categoria: nomeNovaCat }));
                abrirDetalhes({ ...chamadoSelecionado, id_categoria: idNovaCat, nome_categoria: nomeNovaCat });
            } catch (err) {
                MySwal.fire('Erro', 'Não foi possível alterar a categoria.', 'error');
            } finally {
                setAtualizandoCategoria(false);
            }
        } else {
            carregarChamados();
        }
    };

    const realizarAcao = async (novoStatus, msgPadrao = "") => {
        const id = chamadoSelecionado?.id_chamado || chamadoSelecionado?.ID_CHAMADO;
        const statusOriginal = chamadoSelecionado?.status || chamadoSelecionado?.STATUS;
        const mensagemFinal = novaMsg.trim() || msgPadrao;

        if (!mensagemFinal && Number(novoStatus) !== 1) {
            toast.warning("Por favor, escreva uma mensagem ou parecer.");
            return;
        }

        setEnviandoInt(true);
        try {

            const json = {
                id_chamado: id,
                usuario: chapa,
                perfil: 'TECNICO',
                mensagem: mensagemFinal,
                status_novo: Number(novoStatus),
                anexos: anexosNovos.map(a => ({
                    nome: a.nome || a.NOME_ARQUIVO || 'arquivo',
                    base64: a.base64 || a.BASE64
                }))
            };

            console.log('/Interacao');
            console.log(json);

            await api.post('/interacao', json);

            await MySwal.fire({
                icon: 'success',
                title: 'Sucesso!',
                text: 'Operação realizada com sucesso.',
                timer: 2000,
                showConfirmButton: false
            });

            setNovaMsg("");
            setAnexosNovos([]);

            // Fecha o modal de detalhes para atualizar a lista de chamados principal
            setShowDetalhes(false);
            carregarChamados(1);

        } catch (err) {
            console.error(err);
            toast.error("Erro ao processar solicitação");
        } finally {
            setEnviandoInt(false);
        }
    };

    const baixarFicheiroBase64 = (base64Data, nomeArquivo) => {
        try {
            const base64Limpo = base64Data.includes(',') ? base64Data.split(',')[1] : base64Data;
            const byteCharacters = atob(base64Limpo);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray]);

            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = nomeArquivo || 'download';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
            toast.success(`Download de ${nomeArquivo} iniciado!`);
        } catch (e) {
            console.error("Erro ao descarregar ficheiro:", e);
            toast.error("Erro ao efetuar o download do ficheiro.");
        }
    };

    const renderAnexos = (lista) => (
        <Row className="g-1 mt-2">
            {lista.map((f, idx) => {
                const nome = (f.NOME_ARQUIVO || f.nome || "").toLowerCase();
                const base64 = (f.BASE64 || f.base64);

                const isPdf = nome.endsWith('.pdf');
                const isTxt = nome.endsWith('.txt') || nome.endsWith('.txt_conv');
                const isExcel = nome.endsWith('.xlsx') || nome.endsWith('.xls') || nome.endsWith('.csv');
                const isDoc = nome.endsWith('.doc') || nome.endsWith('.docx');

                return (
                    <Col xs={4} key={idx}>
                        <div
                            className="ratio ratio-1x1 border rounded-3 overflow-hidden bg-white d-flex align-items-center justify-content-center shadow-sm"
                            style={{ cursor: 'pointer', minWidth: '60px' }}
                            onClick={() => {
                                if (isPdf || isTxt) {
                                    setPdfSelecionado({ nome, base64 });
                                } else if (isExcel || isDoc) {
                                    baixarFicheiroBase64(base64, f.NOME_ARQUIVO || f.nome);
                                } else {
                                    setFotoSelecionada({
                                        foto: `data:image/jpeg;base64,${base64}`,
                                        nome
                                    });
                                }
                            }}
                        >
                            {isPdf ? (
                                <div className="text-center">
                                    <i className="bi bi-file-pdf text-danger" style={{ fontSize: '1.5rem' }}></i>
                                    <div style={{ fontSize: '8px' }}>PDF</div>
                                </div>
                            ) : isTxt ? (
                                <div className="text-center">
                                    <i className="bi bi-file-earmark-text text-primary" style={{ fontSize: '1.5rem' }}></i>
                                    <div style={{ fontSize: '8px' }}>TXT</div>
                                </div>
                            ) : isExcel ? (
                                <div className="text-center p-1">
                                    <i className="bi bi-file-earmark-excel text-success" style={{ fontSize: '1.5rem' }}></i>
                                    <div className="text-truncate" style={{ fontSize: '8px' }} title={nome}>EXCEL</div>
                                </div>
                            ) : isDoc ? (
                                <div className="text-center p-1">
                                    <i className="bi bi-file-earmark-word text-primary" style={{ fontSize: '1.5rem' }}></i>
                                    <div className="text-truncate" style={{ fontSize: '8px' }} title={nome}>WORD</div>
                                </div>
                            ) : (
                                <img
                                    src={`data:image/jpeg;base64,${base64}`}
                                    alt="anexo"
                                    style={{ objectFit: 'cover', width: '100%', height: '100%' }}
                                />
                            )}
                        </div>
                    </Col>
                );
            })}
        </Row>
    );

    const formatarData = (s) => s ? new Date(s.replace("Z", "")).toLocaleString('pt-BR') : "";

    return (
        <div style={{ paddingTop: '80px', minHeight: '100vh', display: 'flex', flexDirection: 'column', backgroundColor: '#f8f9fa' }}>
            <Menu modulo="ARBOR" />
            <Container>
                {/* BARRA SUPERIOR DE FILTROS E SETOR */}
                <div className="mb-4 bg-white p-3 rounded-3 shadow-sm border">
                    <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
                        <h4 className="fw-bold text-dark mb-0 d-flex align-items-center gap-2">
                            <i className="bi bi-tools" style={{ color: '#8b0000' }}></i>
                            Central Técnica
                        </h4>

                        <Form.Group className="d-flex align-items-center gap-2">
                            <span className="small fw-bold">Setor:</span>
                            <Form.Select
                                size="sm"
                                style={{ width: '180px' }}
                                value={setorSelecionado}
                                onChange={(e) => {
                                    const novoSetor = e.target.value;
                                    setSetorSelecionado(novoSetor);
                                    localStorage.setItem("@Arbor:setorSelecionado", novoSetor);
                                }}
                                className="fw-semibold"
                            >
                                {setoresPermitidosFormatados.map((s, idx) => (
                                    <option key={idx} value={s.id_setor || s.codigo}>
                                        {s.nome_setor || s.descricao}
                                    </option>
                                ))}
                            </Form.Select>
                        </Form.Group>
                    </div>

                    <Row className="mb-1 align-items-center">
                        <Col xs={12} md={6} lg={5}>
                            <CreatableSelect
                                isMulti
                                placeholder="Filtrar lojas (ex: 02, 05...)"
                                value={lojasSelecionadas}
                                onChange={(newValue) => setLojasSelecionadas(newValue)}
                                onCreateOption={(inputValue) => {
                                    const formatada = inputValue.trim().padStart(2, '0');
                                    const newOption = { label: formatada, value: parseInt(formatada) };
                                    setLojasSelecionadas((prev) => [...prev, newOption]);
                                }}
                                className="basic-multi-select"
                                classNamePrefix="select"
                                noOptionsMessage={() => "Digite a loja e dê Enter"}
                                formatCreateLabel={(inputValue) => `Adicionar loja ${inputValue.padStart(2, '0')}`}
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        minHeight: '38px',
                                        border: '1px solid #dee2e6',
                                        borderRadius: '8px'
                                    })
                                }}
                            />
                        </Col>
                        <Col xs={12} md={6} lg={3} className="mt-2 mt-md-0">
                            <Button
                                variant={showFiltrosAvancados ? "secondary" : "outline-secondary"}
                                size="sm"
                                onClick={() => setShowFiltrosAvancados(!showFiltrosAvancados)}
                                className="d-flex align-items-center gap-2 fw-semibold"
                                style={{ height: '38px', borderRadius: '8px' }}
                            >
                                <i className={`bi ${showFiltrosAvancados ? 'bi-chevron-up' : 'bi-sliders'}`}></i>
                                {showFiltrosAvancados ? "Ocultar Filtros" : "Filtros Avançados"}
                                {(filtroNumChamado || filtroCategoria || filtroData || filtroDescricao || filtroMeusAtendimentos) && (
                                    <Badge bg="danger" className="ms-1">Ativo</Badge>
                                )}
                            </Button>
                        </Col>
                    </Row>

                    <Collapse in={showFiltrosAvancados}>
                        <div>
                            <Card className="p-3 mt-3 border-0 bg-light rounded-3 shadow-sm border">
                                <div className="fw-bold mb-2 text-secondary d-flex justify-content-between align-items-center" style={{ fontSize: '0.85rem' }}>
                                    <span><i className="bi bi-funnel-fill me-1" style={{ color: '#8b0000' }}></i> Filtros de Busca Avançados</span>
                                    {(filtroNumChamado || filtroCategoria || filtroData || filtroDescricao || filtroMeusAtendimentos) && (
                                        <span
                                            className="text-danger fw-bold"
                                            style={{ cursor: 'pointer', textDecoration: 'underline' }}
                                            onClick={() => {
                                                setFiltroNumChamado("");
                                                setFiltroCategoria("");
                                                setFiltroData("");
                                                setFiltroDescricao("");
                                                setFiltroMeusAtendimentos(false);
                                            }}
                                        >
                                            Limpar tudo
                                        </span>
                                    )}
                                </div>
                                <Row className="g-2">
                                    <Col xs={6} md={2}>
                                        <Form.Group>
                                            <Form.Label className="small text-muted mb-1">Nº Chamado</Form.Label>
                                            <Form.Control
                                                type="number"
                                                size="sm"
                                                placeholder="Ex: 154"
                                                value={filtroNumChamado}
                                                onChange={(e) => setFiltroNumChamado(e.target.value)}
                                                style={{ height: '38px', borderRadius: '6px' }}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col xs={6} md={3}>
                                        <Form.Group>
                                            <Form.Label className="small text-muted mb-1">Categoria</Form.Label>
                                            <Form.Select
                                                size="sm"
                                                value={filtroCategoria}
                                                onChange={(e) => setFiltroCategoria(e.target.value)}
                                                style={{ height: '38px', borderRadius: '6px' }}
                                            >
                                                <option value="">Todas</option>
                                                {categoriasSetor.map((cat, idx) => (
                                                    <option key={idx} value={cat.nome_categoria || cat.descricao}>
                                                        {cat.nome_categoria || cat.descricao}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>

                                    <Col xs={12} md={3}>
                                        <Form.Group>
                                            <Form.Label className="small text-muted mb-1">Data de Abertura</Form.Label>
                                            <Form.Control
                                                type="date"
                                                size="sm"
                                                value={filtroData}
                                                onChange={(e) => setFiltroData(e.target.value)}
                                                style={{ height: '38px', borderRadius: '6px' }}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col xs={12} md={4}>
                                        <Form.Group>
                                            <Form.Label className="small text-muted mb-1">Termo de busca</Form.Label>
                                            <div className="d-flex gap-2">
                                                <Form.Control
                                                    type="text"
                                                    size="sm"
                                                    placeholder="Buscar na descrição..."
                                                    value={filtroDescricao}
                                                    onChange={(e) => setFiltroDescricao(e.target.value)}
                                                    style={{ height: '38px', borderRadius: '6px' }}
                                                />
                                                {(filtroNumChamado || filtroCategoria || filtroData || filtroDescricao || filtroMeusAtendimentos) && (
                                                    <Button
                                                        variant="outline-danger"
                                                        size="sm"
                                                        title="Limpar todos os filtros"
                                                        style={{ height: '38px', width: '42px', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: '6px' }}
                                                        onClick={() => {
                                                            setFiltroNumChamado("");
                                                            setFiltroCategoria("");
                                                            setFiltroData("");
                                                            setFiltroDescricao("");
                                                            setFiltroMeusAtendimentos(false);
                                                        }}
                                                    >
                                                        <i className="bi bi-trash3-fill"></i>
                                                    </Button>
                                                )}
                                            </div>
                                        </Form.Group>
                                    </Col>

                                    <Col xs={12} className="mt-2 pt-2 border-top">
                                        <Form.Check
                                            type="switch"
                                            id="filter-meus-atendimentos"
                                            label={<strong>Apenas chamados que eu estou atendendo</strong>}
                                            checked={filtroMeusAtendimentos}
                                            onChange={(e) => setFiltroMeusAtendimentos(e.target.checked)}
                                            className="text-danger small"
                                        />
                                    </Col>
                                </Row>
                            </Card>
                        </div>
                    </Collapse>
                </div>

                {/* BOTÕES DE STATUS */}
                <div className="status-container-scroll w-100 mb-4">
                    <ButtonGroup size="sm" className="bg-white shadow-sm rounded-pill p-1 border">
                        {["Em Espera", "Em Atendimento", "Aguardando Usuário", "Aguardando Avaliação", "Encerrados"].map((st) => (
                            <ToggleButton
                                key={st}
                                type="radio"
                                style={filtroStatus === st ? { backgroundColor: '#8b0000', borderColor: '#8b0000', color: '#ffffff' } : { color: '#495057', backgroundColor: 'transparent', border: 'none' }}
                                className="border-0 rounded-pill px-4 fw-semibold"
                                onClick={() => setFiltroStatus(st)}
                            >
                                {st}
                            </ToggleButton>
                        ))}
                    </ButtonGroup>
                </div>

                {loading && chamados.length === 0 && (
                    <div className="text-center mt-5">
                        <Spinner animation="border" style={{ color: '#8b0000' }} />
                    </div>
                )}

                <Row>
                    {chamados.map(c => {
                        const idOrigem = c.id_chamado_origem || c.ID_CHAMADO_ORIGEM;
                        return (
                            <Col md={4} key={c.id_chamado || c.ID_CHAMADO} className="mb-3">
                                <Card className="shadow-sm border-0 h-100" onClick={() => abrirDetalhes(c)} style={{ cursor: 'pointer', borderRadius: '12px' }}>
                                    <div style={{ height: '6px', borderTopLeftRadius: '12px', borderTopRightRadius: '12px', backgroundColor: c.cor_hex || c.COR_HEX || '#8b0000' }} />
                                    <Card.Body>
                                        <div className="d-flex justify-content-between mb-2 align-items-center">
                                            <Badge bg="secondary">Loja {String(c.loja).padStart(2, '0')}</Badge>
                                            <Badge style={{ backgroundColor: c.cor_hex || c.COR_HEX || '#8b0000' }}>{c.status_nome || c.STATUS_NOME}
                                                {c.nota_avaliacao > 0 && c.status === 99 ? (
                                                    <span>
                                                        <b> - Nota: </b>
                                                        {c.nota_avaliacao || c.NOTA_AVALIACAO}
                                                    </span>
                                                ) : null}
                                            </Badge>
                                            <div className="text-muted small fw-bold">
                                                #{c.id_chamado || c.ID_CHAMADO}
                                                {idOrigem && (
                                                    <Badge bg="warning" text="dark" className="ms-1" onClick={(e) => abrirConsultaChamadoPai(e, idOrigem)} title="Clique para consultar Chamado Pai">
                                                        <i className="bi bi-link-45deg me-1"></i>Pai: #{idOrigem}
                                                    </Badge>
                                                )}
                                            </div>
                                        </div>

                                        <Card.Title className="h6 fw-bold">{c.assunto}</Card.Title>
                                        <Card.Text className="small text-muted mb-0">Solicitante: {formatarNomePrimeiro(c.nome_usuario)}</Card.Text>
                                        <Card.Text className="small text-muted mb-0">Categoria: {c.nome_categoria || c.categoria_nome}</Card.Text>

                                        {(c.numero_serie || c.NUMERO_SERIE) && (
                                            <Card.Text className="small text-danger fw-bold text-uppercase mt-1 mb-0">
                                                Nº Série: {c.numero_serie || c.NUMERO_SERIE}
                                            </Card.Text>
                                        )}

                                        <div className="small fw-bold mt-2" style={{ color: '#8b0000' }}>
                                            {formatarData(c.data_abertura)}
                                        </div>
                                        <Card.Text className="small text-muted text-truncate">{decodeBase64(c.descricao || c.DESCRICAO)}</Card.Text>

                                        {c.ultima_data_interacao && (
                                            <div style={{ fontSize: '0.75rem', color: '#666', marginTop: '5px' }}>
                                                <i className="bi bi-reply-all me-1"></i>
                                                <b>Última resposta: </b>{formatarData(c.ultima_data_interacao)} - <b>Usuário: </b>{formatarNomePrimeiro(c.ultima_nome_interacao)}
                                            </div>
                                        )}
                                        {(c.USUARIO_ATENDENDO || c.usuario_atendendo) && (c.dp_setor === 'T' || c.DP_SETOR === 'T') && (
                                            <div className="mt-2">
                                                <Badge bg="warning" text="dark" className="w-100 p-2 d-flex align-items-center justify-content-center">
                                                    <i className="bi bi-person-fill me-1"></i>
                                                    Sendo atendido por: {formatarNomePrimeiro(c.nome_atendendo || c.nome_atendendo).split(' ')[0]}
                                                </Badge>
                                            </div>
                                        )}
                                    </Card.Body>
                                </Card>
                            </Col>
                        );
                    })}
                </Row>

                {loading && chamados.length > 0 && (
                    <div className="text-center my-3">
                        <Spinner animation="border" size="sm" style={{ color: '#8b0000' }} className="me-2" />
                        <span className="text-muted small">Carregando mais...</span>
                    </div>
                )}

                {temMais && (
                    <div className="d-flex justify-content-center my-4">
                        <Button
                            variant="outline-danger"
                            className="fw-bold px-4"
                            onClick={() => carregarChamados(pagina + 1)}
                            disabled={loading}
                        >
                            {loading ? (
                                <><Spinner size="sm" className="me-2" /> Carregando...</>
                            ) : (
                                "Carregar mais chamados"
                            )}
                        </Button>
                    </div>
                )}
            </Container>

            {/* MODAL DETALHES DE ATENDIMENTO */}
            <Modal
                show={showDetalhes}
                onHide={() => setShowDetalhes(false)}
                size="lg"
                centered
                className="modal-fullscreen-mobile"
            >
                <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #8b0000 0%, #a91b0d 50%, #c0392b 100%)', color: '#ffffff' }} className="py-2 px-3 border-0">
                    <Modal.Title className="fs-6 fw-bold text-white m-0">
                        Chamado #{chamadoSelecionado?.id_chamado || chamadoSelecionado?.ID_CHAMADO} - {chamadoSelecionado?.assunto || chamadoSelecionado?.ASSUNTO}
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body style={{ backgroundColor: '#f8f9fa', overflowY: 'auto' }}>
                    {loadingDetalhes ? <div className="text-center p-4"><Spinner animation="border" style={{ color: '#8b0000' }} /></div> : (
                        <>
                            <div
                                id="chat-container"
                                ref={chatContainerRef}
                                style={{
                                    padding: '10px',
                                    backgroundColor: '#f8f9fa'
                                }}
                            >
                                <div className="bg-white p-3 rounded-3 mb-3 shadow-sm border-start border-4 border-danger border">
                                    <Row className="g-2">
                                        <Col xs={6}>
                                            <small className="text-muted d-block">Usuário Solicitante:</small>
                                            <span className="fw-bold text-dark">{formatarNomePrimeiro(chamadoSelecionado?.nome_usuario)}</span>
                                        </Col>
                                        <Col xs={6} className="text-end">
                                            <small className="text-muted d-block">Abertura:</small>
                                            <span className="fw-bold text-dark">{formatarData(chamadoSelecionado?.data_abertura)}</span>
                                        </Col>

                                        <Col xs={12} className="mt-2 pt-2 border-top">
                                            <div className="d-flex justify-content-between align-items-center mb-1">
                                                <small className="text-muted fw-bold">Nº Série / Patrimônio:</small>
                                                {!editandoSerie && (
                                                    <Button
                                                        variant="link"
                                                        size="sm"
                                                        className="p-0 text-decoration-none fw-bold text-danger"
                                                        disabled={modoSomenteLeitura}
                                                        onClick={() => {
                                                            setNovaSerieInput(chamadoSelecionado?.numero_serie || chamadoSelecionado?.NUMERO_SERIE || "");
                                                            setEditandoSerie(true);
                                                        }}
                                                    >
                                                        <i className="bi bi-pencil-square me-1"></i>Alterar
                                                    </Button>
                                                )}
                                            </div>

                                            {editandoSerie ? (
                                                <InputGroup size="sm">
                                                    <Form.Control
                                                        value={novaSerieInput}
                                                        onChange={(e) => setNovaSerieInput(e.target.value.toUpperCase())}
                                                        placeholder="Digite a nova série/patrimônio..."
                                                        style={{ textTransform: 'uppercase' }}
                                                    />
                                                    <Button
                                                        style={{ backgroundColor: '#8b0000', borderColor: '#8b0000', color: '#ffffff' }}
                                                        onClick={salvarNovaSerie}
                                                        disabled={salvandoSerie}
                                                    >
                                                        {salvandoSerie ? <Spinner size="sm" /> : <i className="bi bi-check-lg"></i>}
                                                    </Button>
                                                    <Button
                                                        variant="secondary"
                                                        onClick={() => setEditandoSerie(false)}
                                                        disabled={salvandoSerie}
                                                    >
                                                        <i className="bi bi-x-lg"></i>
                                                    </Button>
                                                </InputGroup>
                                            ) : (
                                                <div>
                                                    <Badge style={{ backgroundColor: '#8b0000' }} className="text-uppercase fs-6">
                                                        {chamadoSelecionado?.numero_serie || chamadoSelecionado?.NUMERO_SERIE || "NÃO INFORMADO"}
                                                    </Badge>
                                                </div>
                                            )}
                                        </Col>

                                        {dadosEquipamento && (
                                            <Col xs={12} className="mt-2">
                                                <div className="bg-light p-2.5 rounded border border-danger border-opacity-25 shadow-sm">
                                                    <h6 className="fw-bold text-danger mb-2 small d-flex align-items-center">
                                                        <i className="bi bi-pc-display me-1 fs-6"></i> Equipamento Vinculado no Sistema
                                                    </h6>
                                                    <Row className="g-1 text-secondary" style={{ fontSize: '0.8rem' }}>
                                                        <Col xs={6}><strong>Tipo:</strong> {dadosEquipamento.EQP_TIPO || dadosEquipamento.eqp_tipo || "N/I"}</Col>
                                                        <Col xs={6}><strong>Marca/Modelo:</strong> {dadosEquipamento.EQP_MARCA || dadosEquipamento.eqp_marca || ""} {dadosEquipamento.EQP_MODELO || dadosEquipamento.eqp_modelo || ""}</Col>
                                                        <Col xs={6}><strong>Status:</strong> <Badge bg="secondary">{dadosEquipamento.DESC_STATUS || dadosEquipamento.desc_status || "N/I"}</Badge></Col>
                                                        <Col xs={6}><strong>Alocado em:</strong> {dadosEquipamento.NOME_USUARIO || dadosEquipamento.NOME_LOJA || dadosEquipamento.nome_loja || "Sem vínculo"}</Col>
                                                    </Row>
                                                </div>
                                            </Col>
                                        )}

                                        {(chamadoSelecionado?.id_chamado_origem || chamadoSelecionado?.ID_CHAMADO_ORIGEM) && (
                                            <Col xs={12} className="mt-2 pt-2 border-top">
                                                <small className="text-muted fw-bold d-block mb-1">Chamado Pai / Origem:</small>
                                                <Badge
                                                    bg="warning"
                                                    text="dark"
                                                    className="fs-6 p-2 fw-bold"
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={(e) => abrirConsultaChamadoPai(e, chamadoSelecionado?.id_chamado_origem || chamadoSelecionado?.ID_CHAMADO_ORIGEM)}
                                                    title="Clique para visualizar o Chamado Pai (Modo Consulta)"
                                                >
                                                    <i className="bi bi-link-45deg me-1"></i>
                                                    Relacionado ao Chamado #{chamadoSelecionado?.id_chamado_origem || chamadoSelecionado?.ID_CHAMADO_ORIGEM} (Clique para abrir)
                                                </Badge>
                                            </Col>
                                        )}

                                        <Col xs={12} className="mt-2">
                                            <small className="text-muted d-block">Categoria Registrada (Técnico pode alterar):</small>
                                            <Form.Select
                                                size="sm"
                                                className="fw-bold text-danger"
                                                value={chamadoSelecionado?.id_categoria}
                                                disabled={
                                                    modoSomenteLeitura || atualizandoCategoria ||
                                                    (chamadoSelecionado?.dp_setor?.toUpperCase() !== "T" && chamadoSelecionado?.DP_SETOR?.toUpperCase() !== "T")
                                                }
                                                onChange={(e) => {
                                                    const label = e.target.options[e.target.selectedIndex].text;
                                                    alterarCategoria(e.target.value, label);
                                                }}
                                            >
                                                {categoriasSetor.map((cat, idx) => (
                                                    <option key={idx} value={cat.id_categoria || cat.codigo}>
                                                        {cat.nome_categoria || cat.descricao}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                            {atualizandoCategoria && <Spinner size="sm" className="mt-1" />}
                                        </Col>
                                    </Row>
                                </div>

                                <div className="bg-white p-3 rounded-3 mb-3 shadow-sm border">
                                    <small className="text-muted fw-bold">Descrição Inicial:</small>
                                    <p className="mb-0 text-dark" style={{ whiteSpace: 'pre-wrap' }}>{renderTextoComLinks(decodeBase64(chamadoSelecionado?.descricao || ""))}</p>
                                    {anexosAbertura.length > 0 && renderAnexos(anexosAbertura)}
                                </div>

                                {interacoes.map((int, i) => {
                                    const souEu = String(int.USUARIO || int.usuario) === String(chapa);

                                    return (
                                        <div
                                            key={i}
                                            className={`d-flex mb-3 ${souEu ? 'justify-content-end' : 'justify-content-start'}`}
                                        >
                                            <div
                                                className="position-relative border shadow-sm"
                                                style={{
                                                    borderRadius: souEu
                                                        ? '12px 12px 4px 12px'
                                                        : '12px 12px 12px 4px',
                                                    backgroundColor: souEu ? '#f8d7da' : '#ffffff',
                                                    maxWidth: '85%',
                                                    padding: '8px 12px',
                                                    display: 'inline-block'
                                                }}
                                            >
                                                {souEu && (
                                                    <span className="fw-bold text-danger d-block mb-1" style={{ fontSize: '11px' }}>
                                                        Você
                                                    </span>
                                                )}
                                                {!souEu && (
                                                    <small className="d-block fw-bold mb-1 text-dark" style={{ fontSize: '11px' }}>
                                                        {formatarNomePrimeiro(int.nome_usuario)}
                                                    </small>
                                                )}

                                                <div style={{ wordBreak: 'break-word', fontSize: '14px', whiteSpace: 'pre-wrap' }}>
                                                    {renderTextoComLinks(decodeBase64(int.mensagem))}
                                                </div>

                                                {int.ANEXOS && int.ANEXOS.length > 0 && (
                                                    <div className="mt-2 border-top pt-1">
                                                        {renderAnexos(int.ANEXOS)}
                                                    </div>
                                                )}

                                                <small
                                                    className="d-block text-end mt-1 text-muted"
                                                    style={{ fontSize: '10px' }}
                                                >
                                                    {(int.descricao)} -  {formatarData(int.data_interacao)}
                                                </small>
                                                {chamadoSelecionado?.nota_avaliacao > 0 && int.status_novo === 99 ? (
                                                    <div className="d-flex justify-content-between mb-2">
                                                        <Badge style={{ backgroundColor: '#8b0000' }}><b>Nota: </b>{chamadoSelecionado?.nota_avaliacao}</Badge>
                                                    </div>
                                                ) : ""}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </>
                    )}
                </Modal.Body>

                <Modal.Footer className="d-block bg-white border-top">
                    {chamadoSelecionado?.dp_setor !== "X" ? (
                        <>
                            {modoSomenteLeitura ? (
                                <div className="alert alert-info py-2 px-3 mb-0 small d-flex align-items-center border-info">
                                    <i className="bi bi-info-circle-fill me-2 text-info"></i>
                                    Você está visualizando este chamado em &nbsp;<strong> modo de consulta</strong>.
                                </div>
                            ) : (
                                <Button
                                    style={{ backgroundColor: '#8b0000', borderColor: '#8b0000', color: '#ffffff' }}
                                    className="w-100 py-2 fw-bold shadow-sm d-flex align-items-center justify-content-center gap-2"
                                    onClick={abrirModalMemo}
                                >
                                    <i className="bi bi-pencil-square fs-5"></i>
                                    Escrever Resposta / Alterar Status
                                </Button>
                            )}
                        </>
                    ) : (
                        <div className="text-center py-2 text-muted small fw-bold">
                            <i className="bi bi-lock-fill me-1"></i> {chamadoSelecionado?.status_nome}.<br /> Novas interações desativadas.
                        </div>
                    )}
                </Modal.Footer>
            </Modal>

            {/* MODAL DE EDIÇÃO COMPLETO */}
            <Modal
                show={showModalMemo}
                onHide={() => setShowModalMemo(false)}
                size="lg"
                centered
                backdrop="static"
                className="modal-fullscreen-mobile"
            >
                <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #8b0000 0%, #a91b0d 50%, #c0392b 100%)', color: '#ffffff' }} className="py-2 px-3 border-0">
                    <Modal.Title className="fs-6 fw-bold text-white m-0 d-flex align-items-center">
                        <i className="bi bi-pencil-square me-2"></i>Escrever Mensagem e Alterar Atendimento
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="bg-light p-3">
                    {/* Seleção de Status */}
                    <Form.Group className="mb-3">
                        <Form.Label className="fw-bold small text-secondary">
                            Status do Chamado <span className="text-danger">*</span>:
                        </Form.Label>
                        <Form.Select
                            className="fw-bold shadow-sm"
                            value={statusSelecionado !== "" && statusSelecionado !== null && statusSelecionado !== undefined ? Number(statusSelecionado) : ""}
                            onChange={(e) => {
                                const val = e.target.value;
                                setStatusSelecionado(val !== "" ? Number(val) : "");
                            }}
                        >
                            <option value="" disabled>Selecione o NOVO STATUS do chamado...</option>
                            {statusSetor.map((st, idx) => {
                                const valStatus = Number(
                                    st.id_status ?? st.ID_STATUS ??
                                    st.id_status_setor ?? st.ID_STATUS_SETOR ??
                                    st.codigo ?? st.CODIGO
                                );
                                return (
                                    <option key={idx} value={valStatus}>
                                        {st.descricao || st.DESCRICAO || st.nome_status || st.NOME_STATUS}
                                    </option>
                                );
                            })}
                            <option value={90}>RESOLVIDO</option>
                        </Form.Select>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label className="fw-bold small text-secondary d-flex justify-content-between align-items-center">
                            <span>Mensagem / Parecer Técnico <span className="text-danger">*</span>:</span>
                            <span className="text-muted" style={{ fontSize: '11px' }}>Dica: Você pode colar prints diretamente aqui (Ctrl+V)</span>
                        </Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={8}
                            className="shadow-sm p-3"
                            placeholder="Escreva o parecer técnico, comandos SQL, explicações..."
                            value={novaMsg}
                            onChange={(e) => setNovaMsg(e.target.value)}
                            onPaste={handlePaste}
                            style={{ fontSize: '15px', resize: 'vertical' }}
                            autoFocus
                        />
                    </Form.Group>

                    <div className="d-flex align-items-center gap-2 mb-2">
                        <input
                            type="file"
                            id="fileModalAtend"
                            hidden
                            multiple
                            onChange={handleFileChange}
                            accept="image/*,application/pdf"
                        />
                        <Button
                            variant="outline-secondary"
                            size="sm"
                            className="bg-white shadow-sm fw-bold d-flex align-items-center gap-1"
                            onClick={() => document.getElementById('fileModalAtend').click()}
                        >
                            <i className="bi bi-paperclip fs-6"></i> Anexar Arquivos / Imagens
                        </Button>
                    </div>

                    {anexosNovos.length > 0 && (
                        <div className="d-flex gap-2 mt-2 flex-wrap bg-white p-2 rounded border">
                            {anexosNovos.map((file, index) => (
                                <Badge key={index} style={{ backgroundColor: '#8b0000' }} className="d-flex align-items-center p-2">
                                    <i className="bi bi-paperclip me-1"></i>
                                    {file.name || file.nome || `Arquivo ${index + 1}`}
                                    <i className="bi bi-x-circle ms-2" style={{ cursor: 'pointer' }} onClick={() => removerAnexo(index)}></i>
                                </Badge>
                            ))}
                        </div>
                    )}
                </Modal.Body>

                <Modal.Footer className="bg-white border-top p-3">
                    <div className="d-flex justify-content-end align-items-center gap-2 w-100 flex-wrap flex-sm-nowrap">
                        <Button
                            variant="secondary"
                            onClick={() => setShowModalMemo(false)}
                            disabled={enviandoInt}
                            style={{ height: '42px', minWidth: '120px' }}
                            className="d-flex align-items-center justify-content-center fw-semibold"
                        >
                            <i className="bi bi-x-circle me-1"></i> Cancelar
                        </Button>

                        <Button
                            variant="outline-danger"
                            onClick={() => handleSubmitInteracao(true)}
                            disabled={enviandoInt || !novaMsg.trim()}
                            style={{ height: '42px', minWidth: '150px' }}
                            className="d-flex align-items-center justify-content-center fw-bold"
                        >
                            <i className="bi bi-arrow-repeat me-1"></i> Manter Status
                        </Button>

                        <Button
                            style={{
                                backgroundColor: '#8b0000',
                                borderColor: '#8b0000',
                                color: '#ffffff',
                                height: '42px',
                                minWidth: '150px'
                            }}
                            onClick={() => handleSubmitInteracao(false)}
                            disabled={enviandoInt || !novaMsg.trim()}
                            className="d-flex align-items-center justify-content-center fw-bold"
                        >
                            {enviandoInt ? <Spinner size="sm" className="me-1" /> : <i className="bi bi-check-circle me-1"></i>}
                            Salvar Status
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>

            {/* MODAL APENAS CONSULTA DO CHAMADO PAI/ORIGEM */}
            <Modal show={showConsultaPai} onHide={() => setShowConsultaPai(false)} size="lg" centered scrollable contentClassName="border-0 shadow-lg" style={{ zIndex: 1060 }}>
                <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #8b0000 0%, #a91b0d 50%, #c0392b 100%)', color: '#ffffff' }} className="py-2 px-3 border-0">
                    <Modal.Title className="fs-6 fw-bold text-white m-0">
                        <i className="bi bi-eye-fill me-2"></i>[MODO CONSULTA] Chamado Pai #{chamadoPaiDados?.id_chamado || chamadoPaiDados?.ID_CHAMADO} - {chamadoPaiDados?.assunto || chamadoPaiDados?.ASSUNTO}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ backgroundColor: '#f8f9fa', maxHeight: '65vh', overflowY: 'auto' }}>
                    {loadingPai ? (
                        <div className="text-center p-4"><Spinner animation="border" style={{ color: '#8b0000' }} /></div>
                    ) : (
                        <>
                            <div className="d-flex justify-content-start mb-4">
                                <div className="shadow-sm p-3 bg-white rounded-3 border" style={{ borderRadius: '0 15px 15px 15px', maxWidth: '85%' }}>
                                    <div className="small mb-2 text-dark">
                                        <strong>Solicitante:</strong> {formatarNomePrimeiro(chamadoPaiDados?.nome_usuario || chamadoPaiDados?.NOME_USUARIO)} <br />
                                        <strong>Setor:</strong> {chamadoPaiDados?.nome_setor || chamadoPaiDados?.NOME_SETOR} <br />
                                        <strong>Loja:</strong> {String(chamadoPaiDados?.loja || chamadoPaiDados?.LOJA || '').padStart(2, '0')} <br />
                                        <strong>Categoria:</strong> {chamadoPaiDados?.categoria_nome || chamadoPaiDados?.CATEGORIA_NOME}
                                    </div>
                                    <div className="small text-dark mb-2" style={{ whiteSpace: 'pre-wrap' }}>
                                        {renderTextoComLinks(decodeBase64(chamadoPaiDados?.descricao || chamadoPaiDados?.DESCRICAO))}
                                    </div>
                                </div>
                            </div>

                            {interacoesPai.map((i, idx) => {
                                const isMe = String(i.CHAPA || i.USUARIO || i.usuario || i.chapa).trim() === String(chapa).trim();
                                return (
                                    <div key={idx} className={`d-flex mb-2 ${isMe ? 'justify-content-end' : 'justify-content-start'}`}>
                                        <div className="p-2 bg-white rounded-3 shadow-sm border" style={{ maxWidth: '85%', backgroundColor: isMe ? '#f8d7da' : '#fff' }}>
                                            <small className="fw-bold text-danger">{isMe ? 'Você' : formatarNomePrimeiro(i.NOME_USUARIO || i.nome_usuario)}</small>
                                            <div className="small text-dark" style={{ whiteSpace: 'pre-wrap' }}>
                                                {renderTextoComLinks(decodeBase64(i.MENSAGEM || i.mensagem))}
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer className="bg-light">
                    <Button variant="secondary" size="sm" className="fw-semibold" onClick={() => setShowConsultaPai(false)}>Fechar Consulta</Button>
                </Modal.Footer>
            </Modal>

            <Foto
                show={!!fotoSelecionada}
                onClose={() => setFotoSelecionada(null)}
                foto={fotoSelecionada?.foto}
                nome={fotoSelecionada?.nome}
                info01=""
                info02=""
            />

            <Modal
                show={!!pdfSelecionado}
                onHide={() => {
                    setPdfSelecionado(null);
                    setFullscreenPdf(false);
                }}
                size="lg"
            >
                <Modal.Header closeButton className="d-flex align-items-center justify-content-between bg-dark text-white">
                    <div className="d-flex align-items-center" style={{ minWidth: 0, flex: 1 }}>
                        <strong
                            className="text-white text-truncate"
                            style={{ fontSize: '0.9rem', maxWidth: '100%', display: 'block' }}
                            title={pdfSelecionado?.nome}
                        >
                            {pdfSelecionado?.nome}
                        </strong>
                    </div>

                    <Button
                        variant="outline-light"
                        size="sm"
                        className="ms-2 flex-shrink-0 fw-bold"
                        onClick={() => setFullscreenPdf(true)}
                        style={{ fontSize: '0.8rem', whiteSpace: 'nowrap' }}
                    >
                        <i className="bi bi-arrows-fullscreen me-1"></i>
                        <span className="d-none d-md-inline">Fullscreen</span>
                    </Button>
                </Modal.Header>

                <Modal.Body style={{ height: '75vh', padding: 0, display: 'flex', flexDirection: 'column' }}>
                    {urlParaVisualizar ? (
                        <>
                            <div className="d-flex justify-content-end p-2 bg-light border-bottom">
                                <Button
                                    style={{ backgroundColor: '#8b0000', borderColor: '#8b0000', color: '#ffffff' }}
                                    size="sm"
                                    className="fw-bold"
                                    onClick={() => {
                                        const link = document.createElement('a');
                                        link.href = urlParaVisualizar;
                                        link.download = pdfSelecionado?.nome || "arquivo";
                                        link.click();
                                    }}
                                >
                                    <i className="bi bi-download me-1"></i> Baixar Arquivo
                                </Button>
                            </div>

                            <iframe
                                src={urlParaVisualizar}
                                width="100%"
                                height="100%"
                                style={{ border: 'none' }}
                                title="Visualizador"
                            />
                        </>
                    ) : (
                        <div className="text-center p-5">Carregando visualização...</div>
                    )}
                </Modal.Body>
            </Modal>

            <PdfFullscreen
                pdf={urlParaVisualizar}
                nome={pdfSelecionado?.nome}
                fullscreen={fullscreenPdf}
                setFullscreen={setFullscreenPdf}
            />

            {setorSelecionado && (
                <div
                    style={{
                        position: 'fixed',
                        bottom: '40px',
                        right: '20px',
                        backgroundColor: 'rgba(33, 37, 41, 0.85)',
                        color: '#fff',
                        padding: '5px 12px',
                        borderRadius: '20px',
                        fontSize: '0.75rem',
                        zIndex: 9999,
                        display: 'flex',
                        alignItems: 'center',
                        border: '1px solid rgba(255, 255, 255, 0.1)',
                        backdropFilter: 'blur(4px)'
                    }}
                >
                    <Spinner
                        animation="border"
                        size="sm"
                        className="me-2 text-danger"
                        style={{ width: '12px', height: '12px', borderWidth: '2px' }}
                    />
                    {Math.floor(segundosParaAtualizar / 60)}:
                    {String(segundosParaAtualizar % 60).padStart(2, '0')}
                </div>
            )}

            <Footer />
        </div>
    );
}

export default AtendimentoTecnico;